export const getToken = () => {
  // Try to get token from localStorage first, then cookies
  return localStorage.getItem('token') || document.cookie.split('; ')
    .find(row => row.startsWith('token='))
    ?.split('=')[1];
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // Clear cookie by setting expired date
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export const setAuthData = (data) => {
  if (data.token) {
    localStorage.setItem('token', data.token);
    // Also set cookie for server-side access
    document.cookie = `token=${data.token}; path=/; max-age=${8 * 60 * 60}; secure; samesite=strict`;
  }
  if (data.user) {
    localStorage.setItem('user', JSON.stringify(data.user));
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};

export const isAdmin = () => {
  const user = getUser();
  return user?.type === 'admin';
};